import { render, staticRenderFns } from "./PreviousTable.vue?vue&type=template&id=343a7a7a&scoped=true&"
import script from "./PreviousTable.vue?vue&type=script&lang=js&"
export * from "./PreviousTable.vue?vue&type=script&lang=js&"
import style0 from "./PreviousTable.vue?vue&type=style&index=0&id=343a7a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a7a7a",
  null
  
)

export default component.exports